import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { configure } from 'sf-frontend';
import { ACTIVE_API_URL, ACTIVE_RUNTIME_MODE } from 'shared/ACTIVE_FRONTEND_CONFIG';
import { APP_VERSION } from 'shared/version';
import { initIndexedDb } from './initIndexedDb';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import { Temporal, UUID } from 'sf-shared';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/explicit-function-return-type, no-extend-native, func-names, @typescript-eslint/unbound-method, @typescript-eslint/no-unnecessary-condition */
// Bandaid fix for Chrome 143+ ICU 77 changes affecting Temporal date formatting
const originalToLocaleString = Temporal.PlainDate.prototype.toLocaleString;
Temporal.PlainDate.prototype.toLocaleString = function (locale?: string, options?: Intl.DateTimeFormatOptions): string {
	// Force MM/DD/YYYY format for en-US with 2-digit month/day
	if (locale === 'en-US' && options?.month === '2-digit' && options?.day === '2-digit' && options?.year === 'numeric') {
		const month = String(this.month).padStart(2, '0');
		const day = String(this.day).padStart(2, '0');
		return `${month}/${day}/${this.year}`;
	}
	// Fall back to original for other cases
	return originalToLocaleString.call(this, locale, options);
};

// @ts-expect-error — BigInt serialization shim
BigInt.prototype.toJSON = function () {
	return this.toString();
};

UUID.prototype.toJSON = function () {
	return this.toString();
};
/* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/explicit-function-return-type, no-extend-native, func-names, @typescript-eslint/unbound-method, @typescript-eslint/no-unnecessary-condition */

if (environment.production) {
	enableProdMode();
}

// Configure sf-frontend with structured environment config
configure({
	activeApiUrl: ACTIVE_API_URL,
	mode: ACTIVE_RUNTIME_MODE,
	version: APP_VERSION,
});

bootstrapApplication(AppComponent, {
	providers: [provideZoneChangeDetection(), importProvidersFrom(AppRoutingModule, FormsModule), provideHttpClient(withInterceptorsFromDi())],
}).catch((err: unknown) => {
	console.error(err); // eslint-disable-line no-console
});

initIndexedDb();
